import React from "react";
import { Wheat, ChefHat, MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const values = [{
  title: "Ingredienti di Sciacca",
  description: "Selezioniamo ogni giorno materie prime del territorio: ricotta fresca, pistacchi e mandorle di Sicilia, per offrirti un gusto autentico che si sente al primo morso.",
  icon: Wheat
}, {
  title: "Fatto a Mano",
  description: "Ogni dolce nasce nel nostro laboratorio, lavorato a mano con cura e passione, proprio come una volta.",
  icon: ChefHat
}, {
  title: "Ricette Secolari",
  description: "Seguiamo le ricette della tradizione siciliana, tramandate nel tempo, per portare sulla tua tavola sapori veri e senza tempo.",
  icon: MapPin
}];
export default function INostriValoriArtigianali() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="i-nostri-valori-artigianali" className="relative w-full py-16 md:py-24 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute inset-0" style={{
        backgroundImage: "radial-gradient(var(--color-ring) 1px, transparent 1px)",
        backgroundSize: "24px 24px",
        opacity: 0.15
      }} />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <p className="text-center text-ring font-serif italic mb-12 transition-all duration-1000 delay-100 opacity-100 !text-2xl">La qualità che senti al primo assaggio</p>
        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          {values.map((value, i) => <Card key={i} data-index={i} className="border-none shadow-none bg-transparent text-center group">
              <CardHeader className="flex flex-col items-center gap-4 pb-2">
                <div className="p-4 rounded-full bg-background/50 ring-1 ring-ring/20 shadow-sm group-hover:ring-ring/50 transition-all duration-300">
                  <value.icon className="w-10 h-10 text-ring stroke-[1.5]" aria-hidden="true" />
                </div>
                <CardTitle className="text-2xl font-serif font-bold text-primary">
                  {value.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base md:text-lg leading-relaxed text-muted-foreground/90">
                  {value.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}